module.exports = __webpack_public_path__ + "static/media/beef-chicken-deluxe.4edf27d7.png";